module.exports = __webpack_public_path__ + "static/media/workClock.d1e4a2c5.svg";